import type { MapperOptions } from '~/types'

export const mapperFormThankYou = (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  const getInternalUrl = options.getInternalUrl

  if (!getInternalUrl) {
    return null
  }

  return {
    thankYouPageLink: getInternalUrl(data?.sys?.id) || ''
  }
}
